// @flow
import React, { PureComponent, Fragment } from 'react';

import ContactForm7 from 'containers/contactForm7/ContactForm7Container';

import '../../contact/contact.css';

type Props = {
  form: any,
  jobid: string,
  jobname: string,
  jobemail: string
};

type State = {};

class JobDetailForm extends PureComponent<Props, State> {
  render() {
    const { form, jobid, jobname, jobemail } = this.props;
    const initialValues = {
      'postuler-id': jobid,
      'postuler-jobname': jobname,
      'postuler-email-candidature': jobemail
    };

    return (
      <Fragment>
        <div className="separator mt-5 mb-5" />
        <h3 className="mb-1">Je postule</h3>
        <p className="ft-black-secondary mb-3">Envoyez-nous juste quelques informations et nous vous contacterons.</p>

        <ContactForm7 formId={form.id} initialValues={initialValues} />
      </Fragment>
    );
  }
}

export default JobDetailForm;
